<script setup lang="ts">
import type { SelectedRegionsSectionClick } from '.';
import type { RouterLinkProps } from 'vue-router';

export type Category = {
	image: string;
	title: string;
	url: RouterLinkProps['to'];
};

const props = defineProps<{
	image?: Category['image'];
	title: Category['title'];
	url?: Category['url'];
	regionTitle: string;
}>();

const eventBus = useEventBus<SelectedRegionsSectionClick>(
	'neighborhood_category_clicked'
);

function handleClick() {
	eventBus.emit({
		clickLocation: 'card clicked',
		cardText: props.title,
		destinationUrl: props.url as string,
		neighborhoodName: props.regionTitle
	});
}
</script>
<template>
	<NuxtLink :to="url" @click="handleClick">
		<div
			class="relative flex h-[120px] w-[185px] md:h-[120px] md:w-[155px] lg:h-[120px] lg:w-[211px] xl:h-[153px] xl:w-[153.5px]"
		>
			<NuxtImg
				v-if="image"
				:src="image"
				class="size-full object-cover"
				width="185"
				height="120"
				format="webp"
				loading="lazy"
			/>
			<div
				class="absolute inset-0 flex items-end justify-start p-4 font-sans text-sm font-medium text-white"
				:class="
					!image ? 'bg-black' : 'bg-linear-to-b from-transparent to-black/60'
				"
			>
				<div class="flex w-full items-center justify-between">
					{{ title }}
					<IconMaterialSymbolsNorthEast class="min-h-4 min-w-4 self-end" />
				</div>
			</div>
		</div>
	</NuxtLink>
</template>
